import * as React from 'react';

import PathwaysCareerOutcomesModule from 'bundles/unified-description-page-common/components/modules/career-outcomes/PathwaysCareerOutcomesModule';
import PathwaysCareerOutcomesPlaceholder from 'bundles/unified-description-page-common/components/modules/career-outcomes/PathwaysCareerOutcomesPlaceholder';
import PathwaysCareerOutcomesModuleRedesign from 'bundles/unified-description-page-common/components/modules/career-outcomes/PathwaysCareeroutcomesModuleRedesign';
import { useCareerRolesData } from 'bundles/unified-description-page-common/contexts/CareerRolesDataContext';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import { getCareerOutcomesValuePropsForSpecialization } from 'bundles/unified-description-page-common/utils/careerOutcomes';
import { SPECIALIZATION_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

type Props = {
  pageData: ConsumerSpecializationPageFieldsFragment;
};

const SpecializationPathwaysCareerOutcomesModuleRenderer = ({ pageData }: Props) => {
  const { data: careerRolesData, loading } = useCareerRolesData();
  const { enableXDPRedesignPhase1, enableXDPRedesignDescriptionRework } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignDescriptionRework;

  const PathwaysCareerOutcomesModuleComponent = enableXDPRedesign
    ? PathwaysCareerOutcomesModuleRedesign
    : PathwaysCareerOutcomesModule;

  if (loading) {
    return <PathwaysCareerOutcomesPlaceholder />;
  }

  if (!careerRolesData) return null;

  return (
    <PathwaysCareerOutcomesModuleComponent
      anchorId={SPECIALIZATION_NAV_ITEMS.OUTCOMES}
      careerGrowthInPercentage={pageData.careerOutcomes?.careerGrowthInPercentage}
      careerRoles={careerRolesData}
      valueProps={getCareerOutcomesValuePropsForSpecialization(pageData.partners?.[0]?.name)}
    />
  );
};

export default SpecializationPathwaysCareerOutcomesModuleRenderer;
